
module.exports = function(a, b){
  var fn = function(){};
  fn.prototype = b.prototype;
  a.prototype = new fn;
  a.prototype.constructor = a;
};


//////////////////
// WEBPACK FOOTER
// C:/DevOnFrameStudio/workspace/ecpl/ecpl-web-resources/node_modules/component-inherit/index.js
// module id = 12
// module chunks = 0 1 2